import React from 'react';
import { Link } from 'react-router-dom';

import cavsLogo from '../../../images/cavs-logo.png';

export default function Nav() {
  return (
    <div>
      <div className="navbar-fixed">
        <nav className="white app-bar fixed" role="navigation">
          <div className="nav-wrapper">
            <Link to="/" className="brand-logo">
              <img src={`../${cavsLogo}`} alt="CAVS logo" className="nav-logo"/>
              <span className="right secondary-text-color site-title">
                Cost Analysis Valuation System
              </span>
            </Link>
          </div>
        </nav>
      </div>
    </div>
  );
}
